import { render, staticRenderFns } from "./shipDetails.vue?vue&type=template&id=74e9704e&"
import script from "./shipDetails.vue?vue&type=script&lang=js&"
export * from "./shipDetails.vue?vue&type=script&lang=js&"
import style0 from "./shipDetails.vue?vue&type=style&index=0&id=74e9704e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports